import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import FeedbackSettingDetailsComponent from '../components/feedbackSettingDetailsComponent'; 
import {  fetchFeedbackQuesAnsList ,fetchQuestionType,fetchEmoji,fetchFeedbackTypes,updateQuestionDetailsSettings,deleteQuestionDetails
     }from '../action/feedbackSettingAction'; 

class FeedbackSettingDetailsContainer extends Component {
    constructor(props) {
        super(props);
         this.updateQuestionDetailsSettings = this.updateQuestionDetailsSettings.bind(this);
          this.deleteQuestionDetails = this.deleteQuestionDetails.bind(this);
        
    }

    componentDidMount() {
        this.props.actions.fetchQuestionType( 
            this.props.dispatch
        ) 
        this.props.actions.fetchEmoji( 
            this.props.dispatch
        ) 
           this.props.actions.fetchFeedbackQuesAnsList( 
                   this.props.dispatch
               )
            this.props.actions.fetchFeedbackTypes( 
                this.props.dispatch
            ) 
    }
    getFeedbackQuesList = () =>{
        this.props.actions.fetchFeedbackQuesAnsList(
            this.props.dispatch
        )
    }
    updateQuestionDetailsSettings(formData) { 
        this.props.actions.updateQuestionDetailsSettings(
            this.props.feedbackSettings.isLoading,
            formData,
            this.props.dispatch
        ) 
    }

    deleteQuestionDetails(questionID) { 
        this.props.actions.deleteQuestionDetails(
            this.props.feedbackSettings.isLoading,
            questionID,
            this.props.dispatch
        ) 
    }
    
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <FeedbackSettingDetailsComponent                                 
                                 updateQuestionDetailsSettings={this.updateQuestionDetailsSettings}
                                feedbackSettings={this.props.feedbackSettings}
                                deleteQuestionDetails={this.deleteQuestionDetails}
                                statusCode={this.props.feedbackSettings.statusCode} 
                                getFeedbackQuesList = {this.getFeedbackQuesList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            fetchFeedbackQuesAnsList ,
            fetchQuestionType,
            fetchEmoji,
            fetchFeedbackTypes,
            updateQuestionDetailsSettings,
            deleteQuestionDetails
        }, dispatch)
    };
};

function mapStateToProps({ feedbackSettingReducer }) { 
    return {  
        feedbackSettings: {
            isLoading: feedbackSettingReducer.isLoading,
            emojiImage:feedbackSettingReducer.emojiImage,
            questionType: feedbackSettingReducer.questionType,
            questionList: feedbackSettingReducer.questionList,
            statusCode: feedbackSettingReducer.statusCode,
            errorMessage: feedbackSettingReducer.errorMessage,
            messageLabel: feedbackSettingReducer.messageLabel,
            FeedbackTypesList : feedbackSettingReducer.FeedbackTypesList
        } 
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeedbackSettingDetailsContainer))